import { Routes, Route } from "react-router-dom";

import SmsProviderListScreen from "screens/App/CRM/SmsProvider/SmsProviderListScreen";
import SmsProviderDetailScreen from "screens/App/CRM/SmsProvider/SmsProviderDetailScreen";
import SmsProviderEditScreen from "screens/App/CRM/SmsProvider/SmsProviderEditScreen";
import SmsProviderCreateScreen from "screens/App/CRM/SmsProvider/SmsProviderCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const SmsProviderRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<SmsProviderListScreen />} />
      <Route path="create" element={<SmsProviderCreateScreen />} />
      <Route path=":id/detail" element={<SmsProviderDetailScreen />} />
      <Route path=":id/edit" element={<SmsProviderEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default SmsProviderRouter;